import React from 'react';
import { Spin } from 'antd';
import { addressInputStyles } from '../styles/addressInput';
import { Loader } from '../../../components/UI/Loader';
import { MapToolbar } from './MapToolbar';
import { useMapToolbar } from '../hooks/useMapToolbar';
import { IMapController } from '../../../lib/map';

import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';

interface MapContainerProps {
  mapRef: React.RefObject<HTMLDivElement> | ((element: HTMLDivElement | null) => void);
  loading: boolean;
  isMobile: boolean;
  showToolbar?: boolean;
  mapController?: IMapController | null;
}

export const MapContainer: React.FC<MapContainerProps> = ({
  mapRef,
  loading,
  isMobile,
  showToolbar = false,
  mapController = null,
}) => {
  const containerStyle = isMobile
    ? addressInputStyles.mapContainer
    : addressInputStyles.mapContainerDesktop;

  const { canUndo, canRedo, hasSelectedMarker, handleUndo, handleRedo, handleDelete } =
    useMapToolbar({ mapController });

  return (
    <div style={{ ...containerStyle, position: 'relative' }}>
      {loading && (
        <div style={addressInputStyles.loadingOverlay}>
          {isMobile ? <Spin size="large" /> : <Loader />}
        </div>
      )}
      {isMobile && <div id="mobile-geocoder" style={addressInputStyles.geocoderContainer} />}
      <div
        ref={mapRef}
        style={{
          height: '100%',
          width: '100%',
          textAlign: isMobile ? 'center' : 'left',
        }}
      />

      {showToolbar && mapController && (
        <MapToolbar
          canUndo={canUndo}
          canRedo={canRedo}
          hasSelectedMarker={hasSelectedMarker}
          onUndo={handleUndo}
          onRedo={handleRedo}
          onDelete={handleDelete}
          isMobile={isMobile}
        />
      )}
    </div>
  );
};
